import React, {Component} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import TooltipClose from "../TooltipClose";
import clsx from "clsx";
import {faInfoCircle} from "@fortawesome/pro-light-svg-icons/faInfoCircle";

class ArticleConfiguratorFormField extends Component {

    constructor(props) {
        super(props);

        this.showRef = props.showRef || React.createRef();
        this.tooltipRef = React.createRef();
        this.labelRef = React.createRef();
    }

    render() {

        const props = this.props;
        const eventProps = {};

        if (!props.label) {
            eventProps.event = 'custom';
            eventProps.eventOff = 'custom';
        }

        return (
            <div
                className={clsx("article-configurator__form-field", !this.props.label && "article-configurator__form-field--hidden")}
            >
                <div
                    className={"article-configurator__form-field__label"}
                >
                    {props.tooltip ? <button
                        type="button"
                        className={"tooltip-wrapper"}
                        data-for={`lswitcher_${props.tooltipId}`}
                        data-tip={""}
                        data-event='click mouseenter focusin'
                        data-event-off='focusout mouseleave'
                        ref={this.showRef}
                    >
                        {props.label ? <span ref={this.labelRef}>{props.label}</span> : null}
                        <FontAwesomeIcon icon={faInfoCircle}/>
                        <ReactTooltip
                            className={clsx("global-tooltip tooltip", !props.label && "tooltip--fixed")}
                            delayShow={props.label ? 250 : 0}
                            delayHide={150}
                            clickable={true}
                            place={props.tooltipPlace || (props.windowWidth < 768 ? "bottom" : "right")}
                            ref={this.tooltipRef}
                            offset={{left: 10}}
                            effect="solid"
                            type="light"
                            border={true}
                            multiline={true}
                            scrollHide={false}
                            id={`lswitcher_${props.tooltipId}`}
                            {...eventProps}
                            overridePosition={(position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset) => {
                                let top = position.top, left = position.left;

                                if (document.body.querySelector('#style_' + node.id)) {
                                    document.body.removeChild(document.body.querySelector('#style_' + node.id));
                                }

                                const sheet = document.createElement('style');
                                const svg = currentTarget.querySelector('svg');
                                sheet.setAttribute('id', 'style_' + node.id);

                                if (place === "right") {

                                    // upper bound
                                    if (top < 84) {
                                        top = 84;
                                    }
                                    // lower bound
                                    if (top + node.getBoundingClientRect().height > document.body.scrollHeight) {
                                        top = document.body.scrollHeight - node.getBoundingClientRect().height - 10;
                                    }

                                    sheet.innerHTML = `
                                        #${node.id} .__react_component_tooltip.place-right::after {
                                            top: ${svg.getBoundingClientRect().bottom - top - 8}px;
                                        }
                                        #${node.id} .__react_component_tooltip.place-right::before {
                                            top: ${svg.getBoundingClientRect().bottom - top - 8}px;
                                        }
                                      `;

                                } else if (place === "bottom") {
                                    top -= 4;

                                    // lower bound
                                    if (top + node.getBoundingClientRect().height > document.body.scrollHeight) {
                                        top = document.body.scrollHeight - node.getBoundingClientRect().height - 10;
                                    }

                                    if (left < 0) {
                                        left = 0;
                                    }

                                    sheet.innerHTML = `
                                        #${node.id} .__react_component_tooltip.place-bottom::after {
                                            left: ${svg.getBoundingClientRect().right - left - 20}px;
                                        }
                                        #${node.id} .__react_component_tooltip.place-bottom::before {
                                            left: ${svg.getBoundingClientRect().right - left - 20}px;
                                        }
                                      `;
                                } else if (place === "top") {

                                    if (left < 0) {
                                        left = 0;
                                    }

                                    sheet.innerHTML = `
                                        #${node.id} .__react_component_tooltip.place-top::after {
                                            left: ${svg.getBoundingClientRect().right - left - 20}px;
                                        }
                                        #${node.id} .__react_component_tooltip.place-top::before {
                                            left: ${svg.getBoundingClientRect().right - left - 20}px;
                                        }
                                      `;

                                    top -= 40;
                                }

                                document.body.appendChild(sheet);

                                return {
                                    left,
                                    top
                                }
                            }}
                        >
                            <TooltipClose tooltip={this.tooltipRef}/>
                            {props.tooltip}
                        </ReactTooltip>
                    </button> : props.label ? <span ref={this.labelRef}>{props.label}</span> : null}
                </div>
                {props.children}
            </div>
        );
    }
}

export default ArticleConfiguratorFormField;



/** WEBPACK FOOTER **
 ** ./src/components/configurator/ArticleConfiguratorFormField.js
 **/